<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary">
        <div class="h4 text-center">
          <linkto :link="'/managers'"/>
          Új kezelő rögzítés
        </div>
      </div>
    </div>
  	<div class="row d-flex justify-content-center">
  		<div class="col-12">
  			<div class="row m-2">
  				<div class="col-12">
  					<div class="row">
  						<div class="col-6 text-center h4">
  							Rögzítette: {{$store.getters.user.nev}}
  						</div>
  						<div class="col-6 text-center h4">
  							Rögzítve: {{datum}}
  						</div>
  					</div>
  				</div>
  			</div>
  			<div class="row d-flex justify-content-center align-items-center">
  				<managerdata
  					:change="false"
            :user="$store.getters.user.nev"
  				>
  				</managerdata>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import moment from 'moment'
import managerdata from './manager_data'
export default {
  name: 'new_manager',
  components: {
  	managerdata
  },
  computed: {
  	datum(){
		  return moment().format('YYYY-MM-DD')
    }
  }
  
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/managers/new_manager.vue